<template>
  <b-modal
    centered
    lazy
    v-model="show"
    title="Virtual Network Information"
    ok-title="Submit"
    @ok="addNetwork"
    @shown="focusMyElement"
  >
    <b-alert variant="danger" class="text-center" v-model="createError" dismissible>
      {{ "Couldn't create network" }}
    </b-alert>
    <b-form class="form">
      <b-form-group label="Description" :invalid-feedback="descriptionError">
        <b-form-input
          name="description"
          ref="focusThis"
          required
          v-validate="'required'"
          placeholder="my-office-network"
          v-on:keyup.enter="addNetwork"
          :state="hasDescriptionError"
          v-model.trim="form.description"
          type="text"
          @keyup.native.enter="addNetwork"
        />
      </b-form-group>

      <b-form-group label="Subnet">
        <b-form-input
          name="subnet"
          required
          readonly
          placeholder="198.18.0.0"
          v-on:keyup.enter="addNetwork"
          v-model.trim="form.subnet"
          type="text"
          @keyup.native.enter="addNetwork"
        />
      </b-form-group>

      <b-form-group label="Netmask">
        <b-form-input
          name="netmask"
          required
          readonly
          placeholder="255.254.0.0"
          v-on:keyup.enter="addNetwork"
          v-model.trim="form.netmask"
          type="text"
          @keyup.native.enter="addNetwork"
        />
      </b-form-group>

      <b-form-group label="Region">
        <b-form-select
          name="region"
          required
          v-validate="'required'"
          v-on:keyup.enter="addNetwork"
          v-model="form.region_tag"
          :options="options"
          type="text"
          @keyup.native.enter="addNetwork"
        >
          <template slot="first">
            <option :value="null" disabled hidden>Select a region</option>
          </template>
        </b-form-select>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
const DEFAULT = {
  description: '',
  subnet: '198.18.0.0',
  netmask: '255.254.0.0',
  region_tag: 'TORONTO1'
}

export default {
  name: 'NetworkModal',
  data: () => ({
    form: { ...DEFAULT },
    createError: false,
    show: true
  }),
  watch: {
    show: function(v) {
      if (!v) {
        this.dismiss()
      }
    }
  },
  computed: {
    ...mapGetters(['regions']),
    options() {
      return this.regions.map(region => ({ value: region.tag, text: region.name }))
    },
    hasDescriptionError() {
      return this.fieldBag.description && this.fieldBag.description.dirty && !this.fieldBag.description.valid
        ? false
        : null
    },
    descriptionError() {
      return this.errors.has('description') ? this.errors.first('description') : ''
    }
  },
  methods: {
    dismiss() {
      this.$router.push({ name: 'dashboard' })
    },
    focusMyElement(e) {
      // https://bootstrap-vue.js.org/docs/components/modal/#auto-focus-on-open
      this.$refs.focusThis.focus()
    },
    addNetwork(event) {
      event.preventDefault()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store
            .dispatch('addNetwork', this.form)
            .then(() => {
              this.dismiss()
            })
            .catch(() => {
              this.createError = true
            })
        } else {
          this.$validator.flag('description', { dirty: true })
          this.$validator.flag('subnet', { dirty: true })
          this.$validator.flag('netmask', { dirty: true })
        }
      })
    }
  }
}
</script>

<style></style>
